import _toConsumableArray from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _defineProperty from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _slicedToArray from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import "core-js/modules/es.string.trim-end.js";
/**
 * @name string-strip-html
 * @fileoverview Strip HTML tags from strings. No parser, accepts mixed sources.
 * @version 11.6.17
 * @author Roy Revelt, Codsen Ltd
 * @license MIT
 * {@link https://codsen.com/os/string-strip-html/}
 */

import te from "lodash.isplainobject";
import le from "lodash.trim";
import $e from "lodash.without";
import { decode as se } from "html-entities";
import { rApply as me } from "ranges-apply";
import { Ranges as ce } from "ranges-push";
import { right as T } from "string-left-right";
function X(t) {
  return /[-_A-Za-z0-9]/.test(t);
}
function _(t, m) {
  if (!t) return [];
  if (Array.isArray(t)) return t.filter(function (D) {
    return typeof D == "string" && D.trim();
  });
  if (typeof t == "string") return t.trim() ? [t] : [];
  throw new TypeError("string-strip-html/stripHtml(): [THROW_ID_05] ".concat(m, " must be array containing zero or more strings or something falsey. Currently it's equal to: ").concat(t, ", that a type of ").concat(typeof t, "."));
}
function ue(t, m, D, c) {
  for (var f = m, b = t.length; f < b; f++) {
    if (t.startsWith(D, f)) return !0;
    if (t.startsWith(c, f)) return !1;
  }
  return !1;
}
function G(t, m, D) {
  return !t || !t.quotes || !ue(m, D + 1, t.quotes.value, ">");
}
var W = new Set(["!doctype", "abbr", "address", "area", "article", "aside", "audio", "base", "bdi", "bdo", "blockquote", "body", "br", "button", "canvas", "caption", "cite", "code", "col", "colgroup", "data", "datalist", "dd", "del", "details", "dfn", "dialog", "div", "dl", "doctype", "dt", "em", "embed", "fieldset", "figcaption", "figure", "footer", "form", "h1", "h2", "h3", "h4", "h5", "h6", "head", "header", "hgroup", "hr", "html", "iframe", "img", "input", "ins", "kbd", "keygen", "label", "legend", "li", "link", "main", "map", "mark", "math", "menu", "menuitem", "meta", "meter", "nav", "noscript", "object", "ol", "optgroup", "option", "output", "param", "picture", "pre", "progress", "rb", "rp", "rt", "rtc", "ruby", "samp", "script", "section", "select", "slot", "small", "source", "span", "strong", "style", "sub", "summary", "sup", "svg", "table", "tbody", "td", "template", "textarea", "tfoot", "th", "thead", "time", "title", "tr", "track", "ul", "var", "video", "wbr", "xml"]),
  j = new Set(["a", "b", "i", "p", "q", "s", "u"]),
  q = new Set([".", ",", ";", "!", "?"]),
  Y = new Set([".", ",", "?", ";", ")", "\u2026", '"', "\xBB"]),
  ee = new Set(["a", "abbr", "acronym", "audio", "b", "bdi", "bdo", "big", "button", "canvas", "cite", "code", "data", "datalist", "del", "dfn", "em", "embed", "i", "iframe", "input", "ins", "kbd", "label", "map", "mark", "meter", "noscript", "object", "output", "picture", "progress", "q", "ruby", "s", "samp", "select", "slot", "small", "span", "strong", "sub", "sup", "svg", "template", "textarea", "time", "u", "tt", "var", "video", "wbr"]);
var ne = "11.6.17";
var Ne = ne,
  oe = {
    ignoreTags: [],
    ignoreTagsWithTheirContents: [],
    onlyStripTags: [],
    stripTogetherWithTheirContents: ["script", "style", "xml"],
    skipHtmlDecoding: !1,
    trimOnlySpaces: !1,
    stripRecognisedHTMLOnly: !1,
    dumpLinkHrefsNearby: {
      enabled: !1,
      putOnNewLine: !1,
      wrapHeads: "",
      wrapTails: ""
    },
    cb: null,
    reportProgressFunc: null,
    reportProgressFuncFrom: 0,
    reportProgressFuncTo: 100
  };
function be(t, m) {
  var D = Date.now(),
    c = [],
    f = [],
    b = [],
    $ = [],
    n = {};
  function ae() {
    n = {
      attributes: []
    };
  }
  ae();
  var V = null,
    w = null,
    N = null,
    J = !1,
    o = {},
    d = {
      tagName: "",
      hrefValue: "",
      openingTagEnds: void 0
    },
    E = "",
    R = !1,
    B = null,
    F = !0;
  function H(e, s, a) {
    if (Array.isArray(s.stripTogetherWithTheirContents) && (s.stripTogetherWithTheirContents.includes(n.name) || s.stripTogetherWithTheirContents.includes("*"))) {
      if (n.slashPresent && Array.isArray(c) && c.some(function (r) {
        return r.name === n.name;
      })) {
        var _loop = function _loop(r) {
          if (c[r].name === n.name) {
            $ = $.filter(function (_ref) {
              var _ref2 = _slicedToArray(_ref, 2),
                u = _ref2[0],
                p = _ref2[1];
              return (u < c[r].lastOpeningBracketAt || u >= e + 1) && (p <= c[r].lastOpeningBracketAt || p > e + 1);
            });
            var g = e + 1;
            n.lastClosingBracketAt && (g = n.lastClosingBracketAt + 1), $.push([c[r].lastOpeningBracketAt, g]), Y.has(t[e]) && s.cb ? s.cb({
              tag: n,
              deleteFrom: c[r].lastOpeningBracketAt,
              deleteTo: e + 1,
              insert: null,
              rangesArr: a,
              proposedReturn: [c[r].lastOpeningBracketAt, e, null]
            }) : s.cb && s.cb({
              tag: n,
              deleteFrom: c[r].lastOpeningBracketAt,
              deleteTo: e,
              insert: "",
              rangesArr: a,
              proposedReturn: [c[r].lastOpeningBracketAt, e, ""]
            }), c.splice(r, 1);
            return "break";
          }
        };
        for (var r = c.length; r--;) {
          var _ret = _loop(r);
          if (_ret === "break") break;
        }
      } else n.slashPresent || c.push(n);
    } else Array.isArray(s.ignoreTagsWithTheirContents) && U(e, s, n) && (F = !1);
  }
  function L(e, s, a, r, g, u) {
    var _l$dumpLinkHrefsNearb;
    if (Array.isArray(i.current()) && typeof a == "number" && i.current()[0][0] === 0 && i.current()[0][1] >= a) return "";
    if (t.length === r && u && (!l.dumpLinkHrefsNearby || !((_l$dumpLinkHrefsNearb = l.dumpLinkHrefsNearby) !== null && _l$dumpLinkHrefsNearb !== void 0 && _l$dumpLinkHrefsNearb.enabled))) return null;
    var p = "";
    if (Number.isInteger(a) && a < g && (p += e.slice(a, g)), Number.isInteger(r) && r > u + 1) {
      var S = e.slice(u + 1, r);
      r && !T(t, r - 1) && (S = S.trimEnd()), S.includes("\n") && y(r, e) ? p += " " : p += S;
    }
    var P = !Y.has(e[s]),
      Q = e[r - 1] !== ">" || !e[a].trim(),
      Z = !['"', "("].includes(e[g - 1]),
      ie = ![";", ".", ":", "!"].includes(e[s]);
    if ((P || Q && Z && ie) && (Q || Z) && e[s] !== "!" && (!ee.has(n.name) || typeof a == "number" && a < g || typeof r == "number" && r > u + 1)) {
      var _S = p.match(/\n/g);
      return Array.isArray(_S) && _S.length ? _S.length === 1 ? "\n" : _S.length === 2 ? "\n\n" : "\n\n\n" : " ";
    }
    return "";
  }
  function x(e, s) {
    var _e$dumpLinkHrefsNearb;
    if ((_e$dumpLinkHrefsNearb = e.dumpLinkHrefsNearby) !== null && _e$dumpLinkHrefsNearb !== void 0 && _e$dumpLinkHrefsNearb.enabled && d.tagName && d.tagName === n.name && n.lastOpeningBracketAt && (d.openingTagEnds && n.lastOpeningBracketAt > d.openingTagEnds || !d.openingTagEnds) && (R = !0), R) {
      var _e$dumpLinkHrefsNearb2;
      var a = (_e$dumpLinkHrefsNearb2 = e.dumpLinkHrefsNearby) !== null && _e$dumpLinkHrefsNearb2 !== void 0 && _e$dumpLinkHrefsNearb2.putOnNewLine ? "\n\n" : "";
      E = "".concat(a).concat(d.hrefValue), (typeof s != "number" || T(t, s - 1)) && (E += a);
    }
  }
  function y(e, s) {
    return s ? s[e] === "<" && s[e + 1] !== "%" : t[e] === "<" && t[e + 1] !== "%";
  }
  function A(e) {
    return t[e] === ">" && t[e - 1] !== "%";
  }
  function U(e, s, a) {
    if (s.ignoreTagsWithTheirContents.includes("*")) return !0;
    var r = t.indexOf("<".concat(a.name), e),
      g = t.indexOf("</".concat(a.name), e);
    return !a.slashPresent && g === -1 || a.slashPresent && !f.some(function (u) {
      return u.name === a.name;
    }) || g > -1 && r > -1 && r < g ? !1 : s.ignoreTagsWithTheirContents.includes(a.name);
  }
  if (typeof t != "string") throw new TypeError("string-strip-html/stripHtml(): [THROW_ID_01] Input must be string! Currently it's: ".concat((typeof t).toLowerCase(), ", equal to:\n").concat(JSON.stringify(t, null, 4)));
  if (m) if (te(m)) {
    if (m.reportProgressFunc && typeof m.reportProgressFunc != "function") throw new Error("string-strip-html/stripHtml(): [THROW_ID_03] the opts.reportProgressFunc, callback function, should be a function but it was given as type ".concat(typeof m.reportProgressFunc, ", equal to ").concat(JSON.stringify(m.reportProgressFunc, null, 4)));
    if (typeof m.dumpLinkHrefsNearby == "boolean" && m.dumpLinkHrefsNearby != null) throw new Error("string-strip-html/stripHtml(): [THROW_ID_04] the opts.dumpLinkHrefsNearby should be a plain object but it was given as type ".concat(typeof m.dumpLinkHrefsNearby, ", equal to ").concat(JSON.stringify(m.dumpLinkHrefsNearby, null, 4)));
  } else throw new TypeError("string-strip-html/stripHtml(): [THROW_ID_02] Optional Options Object must be a plain object! Currently it's: ".concat((typeof m).toLowerCase(), ", equal to:\n").concat(JSON.stringify(m, null, 4)));
  function M() {
    R && (d = {
      tagName: "",
      hrefValue: "",
      openingTagEnds: void 0
    }, R = !1);
  }
  var l = _objectSpread(_objectSpread(_objectSpread({}, oe), m), {}, {
    dumpLinkHrefsNearby: _objectSpread(_objectSpread({}, oe.dumpLinkHrefsNearby), m === null || m === void 0 ? void 0 : m.dumpLinkHrefsNearby)
  });
  if (Object.prototype.hasOwnProperty.call(l, "returnRangesOnly")) throw new TypeError("string-strip-html/stripHtml(): [THROW_ID_05] resolvedOpts.returnRangesOnly has been removed from the API since v.5 release.");
  if (l.reportProgressFuncFrom && typeof l.reportProgressFuncFrom != "number") throw new Error("string-strip-html/stripHtml(): [THROW_ID_06] the resolvedOpts.reportProgressFuncFrom, callback function's \"from\" range, should be a number but it was given as type ".concat(typeof l.reportProgressFuncFrom, ", equal to ").concat(JSON.stringify(l.reportProgressFuncFrom, null, 4)));
  if (l.reportProgressFuncTo && typeof l.reportProgressFuncTo != "number") throw new Error("string-strip-html/stripHtml(): [THROW_ID_07] the resolvedOpts.reportProgressFuncTo, callback function's \"to\" range, should be a number but it was given as type ".concat(typeof l.reportProgressFuncTo, ", equal to ").concat(JSON.stringify(l.reportProgressFuncTo, null, 4)));
  l.ignoreTags = _(l.ignoreTags, "resolvedOpts.ignoreTags"), l.onlyStripTags = _(l.onlyStripTags, "resolvedOpts.onlyStripTags");
  var z = !!l.onlyStripTags.length;
  l.onlyStripTags.length && l.ignoreTags.length && (l.onlyStripTags = $e.apply(void 0, [l.onlyStripTags].concat(_toConsumableArray(l.ignoreTags)))), l.stripTogetherWithTheirContents ? typeof l.stripTogetherWithTheirContents == "string" && l.stripTogetherWithTheirContents.length && (l.stripTogetherWithTheirContents = [l.stripTogetherWithTheirContents]) : l.stripTogetherWithTheirContents = [];
  var I = {};
  if (l.stripTogetherWithTheirContents && Array.isArray(l.stripTogetherWithTheirContents) && l.stripTogetherWithTheirContents.length && !l.stripTogetherWithTheirContents.every(function (e, s) {
    return typeof e != "string" ? (I.el = e, I.i = s, !1) : !0;
  })) throw new TypeError("string-strip-html/stripHtml(): [THROW_ID_08] Optional Options Object's key stripTogetherWithTheirContents was set to contain not just string elements! For example, element at index ".concat(I.i, " has a value ").concat(I.el, " which is not string but ").concat((typeof I.el).toLowerCase(), "."));
  l.cb || (l.cb = function (_ref3) {
    var e = _ref3.rangesArr,
      s = _ref3.proposedReturn;
    s && e.push.apply(e, _toConsumableArray(s));
  });
  var i = new ce({
    limitToBeAddedWhitespace: !0,
    limitLinebreaksCount: 2
  });
  if (!l.skipHtmlDecoding) for (; t !== se(t, {
    scope: "strict"
  });) {
    t = se(t, {
      scope: "strict"
    });
  }
  var C = !1,
    k = !1,
    v = 0,
    K = 0,
    h = t.length,
    re = Math.floor(h / 2);
  var _loop2 = function _loop2(_e) {
    var _n$quotes, _n$quotes2, _l$dumpLinkHrefsNearb5;
    if (l.reportProgressFunc && (h > 1e3 && h < 2e3 ? _e === re && l.reportProgressFunc(Math.floor((l.reportProgressFuncTo - l.reportProgressFuncFrom) / 2)) : h >= 2e3 && (v = l.reportProgressFuncFrom + Math.floor(_e / h * (l.reportProgressFuncTo - l.reportProgressFuncFrom)), v !== K && (K = v, l.reportProgressFunc(v)))), Object.keys(n).length > 1 && n.lastClosingBracketAt && n.lastClosingBracketAt < _e && t[_e] !== " " && B === null && (B = _e), !C && t[_e] === "%" && t[_e - 1] === "{" && t.includes("%}", _e + 1)) {
      N = null;
      var _s = t.indexOf("%}", _e) - 1;
      if (_s > _e) {
        _e = _s;
        e = _e;
        return "continue";
      }
    }
    if (!C && A(_e) && (!n || Object.keys(n).length < 2) && _e > 1) {
      for (var _s2 = _e; _s2--;) {
        if (t[_s2 - 1] === void 0 || A(_s2)) {
          var _ret3 = function () {
            var a = t[_s2 - 1] === void 0 ? _s2 : _s2 + 1,
              r = t.slice(a, _e + 1);
            if (t !== "<".concat(le(r.trim(), "/>"), ">") && _toConsumableArray(W).some(function (g) {
              return le(r.trim().split(/\s+/).filter(function (u) {
                return u.trim();
              }).filter(function (u, p) {
                return p === 0;
              }), "/>").toLowerCase() === g;
            }) && be("<".concat(r.trim(), ">"), l).result === "") {
              (!b.length || b[b.length - 1][0] !== n.lastOpeningBracketAt) && b.push([a, _e + 1]), (!$.length || $[$.length - 1][0] !== n.lastOpeningBracketAt) && $.push([a, _e + 1]);
              var g = L(t, _e, a, _e + 1, a, _e + 1),
                u = _e + 1;
              if (t[u] && !t[u].trim()) {
                for (var p = u; p < h; p++) {
                  if (t[p].trim()) {
                    u = p;
                    break;
                  }
                }
              }
              l.cb({
                tag: n,
                deleteFrom: a,
                deleteTo: u,
                insert: g,
                rangesArr: i,
                proposedReturn: [a, u, g]
              });
            }
            return "break";
          }();
          if (_ret3 === "break") break;
        }
      }
    }
    if (!k && t[_e] === "/" && !((_n$quotes = n.quotes) !== null && _n$quotes !== void 0 && _n$quotes.value) && Number.isInteger(n.lastOpeningBracketAt) && !Number.isInteger(n.lastClosingBracketAt) && (n.slashPresent = _e), t[_e] === '"' || t[_e] === "'") if (!k && n.nameStarts && n.quotes && n.quotes.value && n.quotes.value === t[_e]) {
      var _l$dumpLinkHrefsNearb2;
      o.valueEnds = _e, o.value = t.slice(o.valueStarts, _e), n.attributes.push(o), o = {}, delete n.quotes;
      var _s3;
      ((_l$dumpLinkHrefsNearb2 = l.dumpLinkHrefsNearby) === null || _l$dumpLinkHrefsNearb2 === void 0 ? void 0 : _l$dumpLinkHrefsNearb2.enabled) && !c.length && n.attributes.some(function (a) {
        if (typeof a.name == "string" && a.name.toLowerCase() === "href") {
          var _l$dumpLinkHrefsNearb3, _l$dumpLinkHrefsNearb4;
          e = _e;
          return _s3 = "".concat(((_l$dumpLinkHrefsNearb3 = l.dumpLinkHrefsNearby) === null || _l$dumpLinkHrefsNearb3 === void 0 ? void 0 : _l$dumpLinkHrefsNearb3.wrapHeads) || "").concat(a.value).concat(((_l$dumpLinkHrefsNearb4 = l.dumpLinkHrefsNearby) === null || _l$dumpLinkHrefsNearb4 === void 0 ? void 0 : _l$dumpLinkHrefsNearb4.wrapTails) || ""), !0;
        }
      }) && (d = {
        tagName: n.name,
        hrefValue: _s3,
        openingTagEnds: void 0
      });
    } else !k && !n.quotes && n.nameStarts && (n.quotes = {}, n.quotes.value = t[_e], n.quotes.start = _e, o.nameStarts && o.nameEnds && o.nameEnds < _e && o.nameStarts < _e && !o.valueStarts && (o.name = t.slice(o.nameStarts, o.nameEnds)));
    if (n.nameStarts !== void 0 && n.nameEnds === void 0 && (!t[_e].trim() || !X(t[_e]))) {
      if (n.nameEnds = _e, n.name = t.slice(n.nameStarts, n.nameEnds + (!A(_e) && t[_e] !== "/" && t[_e + 1] === void 0 ? 1 : 0)), t[n.nameStarts - 1] !== "!" && !n.name.replace(/-/g, "").length || /^\d+$/.test(n.name[0])) {
        n = {};
        e = _e;
        return "continue";
      }
      if (typeof n.name == "string" && n.name.toLowerCase() === "doctype" && (k = !0), y(_e)) {
        x(l);
        var _s4 = L(t, _e, n.leftOuterWhitespace, _e, n.lastOpeningBracketAt, _e);
        (l.stripTogetherWithTheirContents.includes(n.name) || l.stripTogetherWithTheirContents.includes("*")) && ($ = $.filter(function (_ref4) {
          var _ref5 = _slicedToArray(_ref4, 2),
            a = _ref5[0],
            r = _ref5[1];
          return !(a === n.leftOuterWhitespace && r === _e);
        })), l.cb({
          tag: n,
          deleteFrom: n.leftOuterWhitespace,
          deleteTo: _e,
          insert: "".concat(_s4).concat(E).concat(_s4),
          rangesArr: i,
          proposedReturn: [n.leftOuterWhitespace, _e, "".concat(_s4).concat(E).concat(_s4)]
        }), M(), H(_e, l, i);
      }
    }
    if ((_n$quotes2 = n.quotes) !== null && _n$quotes2 !== void 0 && _n$quotes2.start && n.quotes.start < _e && !n.quotes.end && o.nameEnds && o.equalsAt && !o.valueStarts && (o.valueStarts = _e), !n.quotes && o.nameEnds && t[_e] === "=" && !o.valueStarts && !o.equalsAt && (o.equalsAt = _e), !n.quotes && o.nameStarts && o.nameEnds && !o.valueStarts && t[_e].trim() && t[_e] !== "=" && (n.attributes.push(o), o = {}), !n.quotes && o.nameStarts && !o.nameEnds && (k && "'\"".includes(t[o.nameStarts]) ? o.nameStarts < _e && t[_e] === t[o.nameStarts] && (o.nameEnds = _e + 1, o.name = t.slice(o.nameStarts, o.nameEnds)) : t[_e].trim() ? t[_e] === "=" ? o.equalsAt || (o.nameEnds = _e, o.equalsAt = _e, o.name = t.slice(o.nameStarts, o.nameEnds)) : t[_e] === "/" || A(_e) ? (o.nameEnds = _e, o.name = t.slice(o.nameStarts, o.nameEnds), n.attributes.push(o), o = {}) : y(_e) && (o.nameEnds = _e, o.name = t.slice(o.nameStarts, o.nameEnds), n.attributes.push(o), o = {}) : (o.nameEnds = _e, o.name = t.slice(o.nameStarts, o.nameEnds))), !n.quotes && n.nameEnds < _e && !t[_e - 1].trim() && t[_e].trim() && !"<>/!".includes(t[_e]) && !o.nameStarts && !n.lastClosingBracketAt && (o.nameStarts = _e), n.lastOpeningBracketAt !== null && n.lastOpeningBracketAt < _e && t[_e] === "/" && n.onlyPlausible && (n.onlyPlausible = !1), n.lastOpeningBracketAt !== null && n.lastOpeningBracketAt < _e && t[_e] !== "/" && (n.onlyPlausible === void 0 && ((!t[_e].trim() || y(_e)) && !n.slashPresent ? n.onlyPlausible = !0 : n.onlyPlausible = !1), t[_e].trim() && n.nameStarts === void 0 && !y(_e) && t[_e] !== "/" && !A(_e) && t[_e] !== "!" && (n.nameStarts = _e, n.nameContainsLetters = !1)), n.nameStarts && !n.quotes && typeof t[_e] == "string" && t[_e].toLowerCase() !== t[_e].toUpperCase() && (n.nameContainsLetters = !0), A(_e) && G(n, t, _e) && !0 && n.lastOpeningBracketAt !== void 0 && (n.lastClosingBracketAt = _e, B = null, Object.keys(o).length && (n.attributes.push(o), o = {}), (_l$dumpLinkHrefsNearb5 = l.dumpLinkHrefsNearby) !== null && _l$dumpLinkHrefsNearb5 !== void 0 && _l$dumpLinkHrefsNearb5.enabled && d.tagName && !d.openingTagEnds && (d.openingTagEnds = _e)), (!k || t[_e] === ">") && n.lastOpeningBracketAt !== void 0) {
      if (n.lastClosingBracketAt === void 0) {
        if (n.lastOpeningBracketAt < _e && !y(_e) && (t[_e + 1] === void 0 || y(_e + 1)) && n.nameContainsLetters && typeof n.nameStarts == "number") {
          if (n.name = t.slice(n.nameStarts, n.nameEnds || _e + 1).toLowerCase(), (!b.length || b[b.length - 1][0] !== n.lastOpeningBracketAt) && b.push([n.lastOpeningBracketAt, _e + 1]), l.ignoreTags.includes(n.name) || U(_e, l, n) || !W.has(n.name) && (n.onlyPlausible || l.stripRecognisedHTMLOnly)) {
            n = {}, o = {};
            e = _e;
            return "continue";
          }
          if ((W.has(n.name) || j.has(n.name)) && (n.onlyPlausible === !1 || n.onlyPlausible === !0 && n.attributes.length) || t[_e + 1] === void 0) {
            x(l);
            var _s5 = L(t, _e, n.leftOuterWhitespace, _e + 1, n.lastOpeningBracketAt, n.lastClosingBracketAt);
            C && n.name === "script" && n.slashPresent && (C = !1);
            var _a;
            _s5 === null || E === null ? _a = null : _a = "".concat(_s5).concat(E).concat(_s5), l.cb({
              tag: n,
              deleteFrom: n.leftOuterWhitespace,
              deleteTo: _e + 1,
              insert: _a,
              rangesArr: i,
              proposedReturn: [n.leftOuterWhitespace, _e + 1, _a]
            }), M(), H(_e, l, i);
          }
          if (!$.length || $[$.length - 1][0] !== n.lastOpeningBracketAt && $[$.length - 1][1] !== _e + 1) if (l.stripTogetherWithTheirContents.includes(n.name) || l.stripTogetherWithTheirContents.includes("*")) {
            var _s6;
            for (var _a2 = c.length; _a2--;) {
              c[_a2].name === n.name && (_s6 = c[_a2]);
            }
            _s6 ? ($ = $.filter(function (_ref6) {
              var _ref7 = _slicedToArray(_ref6, 1),
                a = _ref7[0];
              return a !== _s6.lastOpeningBracketAt;
            }), $.push([_s6.lastOpeningBracketAt, _e + 1])) : $.push([n.lastOpeningBracketAt, _e + 1]);
          } else $.push([n.lastOpeningBracketAt, _e + 1]);
        }
      } else if (_e > n.lastClosingBracketAt && t[_e].trim() || t[_e + 1] === void 0) {
        var _n$attributes;
        var _s7 = n.lastClosingBracketAt === _e ? _e + 1 : _e;
        l.trimOnlySpaces && _s7 === h - 1 && B !== null && B < _e && (_s7 = B), (!b.length || b[b.length - 1][0] !== n.lastOpeningBracketAt) && b.push([n.lastOpeningBracketAt, n.lastClosingBracketAt + 1]);
        var _a3 = l.ignoreTags.includes(n.name),
          r = U(_e, l, n);
        if (!F || l.stripRecognisedHTMLOnly && typeof n.name == "string" && !W.has(n.name.toLowerCase()) && !j.has(n.name.toLowerCase()) || !z && (_a3 || r) || z && !l.onlyStripTags.includes(n.name)) {
          if (r) if (n.slashPresent) {
            for (var g = f.length; g--;) {
              if (f[g].name === n.name) {
                f.splice(g, 1);
                break;
              }
            }
            f.length || (F = !0);
          } else F && (F = !1), f.push(n);
          l.cb({
            tag: n,
            deleteFrom: null,
            deleteTo: null,
            insert: null,
            rangesArr: i,
            proposedReturn: null
          }), n = {}, o = {};
        } else if (!n.onlyPlausible || n.attributes.length === 0 && n.name && (W.has(n.name.toLowerCase()) || j.has(n.name.toLowerCase())) || (_n$attributes = n.attributes) !== null && _n$attributes !== void 0 && _n$attributes.some(function (g) {
          return g.equalsAt;
        })) {
          var _l$dumpLinkHrefsNearb6, _l$dumpLinkHrefsNearb7;
          (!$.length || $[$.length - 1][0] !== n.lastOpeningBracketAt) && $.push([n.lastOpeningBracketAt, n.lastClosingBracketAt + 1]);
          var _g = L(t, _e, n.leftOuterWhitespace, _s7, n.lastOpeningBracketAt, n.lastClosingBracketAt);
          E = "", R = !1, x(l, _s7);
          var u;
          typeof E == "string" && E.length ? (u = "".concat(_g).concat(E).concat(_g === "\n\n" ? "\n" : _g), _s7 === n.lastClosingBracketAt + 1 && (!t[_s7] || !q.has(t[_s7])) && (u += " "), n.leftOuterWhitespace === n.lastOpeningBracketAt && i.last() && i.last()[1] < n.lastOpeningBracketAt && (!l.dumpLinkHrefsNearby || !((_l$dumpLinkHrefsNearb6 = l.dumpLinkHrefsNearby) !== null && _l$dumpLinkHrefsNearb6 !== void 0 && _l$dumpLinkHrefsNearb6.putOnNewLine) || !q.has(t[_s7])) && (u = " " + u)) : u = _g, u !== null && (n.leftOuterWhitespace === 0 || !T(t, _s7 - 1)) && (!((_l$dumpLinkHrefsNearb7 = l.dumpLinkHrefsNearby) !== null && _l$dumpLinkHrefsNearb7 !== void 0 && _l$dumpLinkHrefsNearb7.enabled) || n.name !== "a") && (u = void 0);
          var p = 0;
          if (R && q.has(t[_s7])) {
            var _l$dumpLinkHrefsNearb8, _u;
            ((_l$dumpLinkHrefsNearb8 = l.dumpLinkHrefsNearby) === null || _l$dumpLinkHrefsNearb8 === void 0 ? void 0 : _l$dumpLinkHrefsNearb8.putOnNewLine) && (u = "".concat(t[_s7]).concat(u || ""));
            var P = T(t, _s7);
            P && (_u = u) !== null && _u !== void 0 && _u.endsWith("\n") ? p += P - _e : (!P || P > _e) && p++;
          }
          l.cb({
            tag: n,
            deleteFrom: n.leftOuterWhitespace,
            deleteTo: _s7 + p,
            insert: u,
            rangesArr: i,
            proposedReturn: [n.leftOuterWhitespace, _s7 + p, u]
          }), M(), H(_e, l, i);
        } else n = {};
        A(_e) || (n = {});
      }
      k && (k = !1);
    }
    if ((!C || t[_e] === "<" && T(t, T(t, _e)) && t[T(t, _e)] === "/" && t.startsWith("script", T(t, T(t, _e)))) && y(_e) && !y(_e - 1) && !"'\"".includes(t[_e + 1]) && (!"'\"".includes(t[_e + 2]) || /\w/.test(t[_e + 1])) && !(t[_e + 1] === "c" && t[_e + 2] === ":") && !(t[_e + 1] === "f" && t[_e + 2] === "m" && t[_e + 3] === "t" && t[_e + 4] === ":") && !(t[_e + 1] === "s" && t[_e + 2] === "q" && t[_e + 3] === "l" && t[_e + 4] === ":") && !(t[_e + 1] === "x" && t[_e + 2] === ":") && !(t[_e + 1] === "f" && t[_e + 2] === "n" && t[_e + 3] === ":") && G(n, t, _e)) {
      if (A(T(t, _e))) {
        e = _e;
        return "continue";
      }
      if (n.nameEnds && n.nameEnds < _e && !n.lastClosingBracketAt && (n.onlyPlausible === !0 && n.attributes && n.attributes.length || n.onlyPlausible === !1)) {
        var _s8 = L(t, _e, n.leftOuterWhitespace, _e, n.lastOpeningBracketAt, _e);
        l.cb({
          tag: n,
          deleteFrom: n.leftOuterWhitespace,
          deleteTo: _e,
          insert: _s8,
          rangesArr: i,
          proposedReturn: [n.leftOuterWhitespace, _e, _s8]
        }), H(_e, l, i), n = {}, o = {};
      }
      if (n.lastOpeningBracketAt !== void 0 && n.onlyPlausible && n.name && !n.quotes && (n.lastOpeningBracketAt = void 0, n.name = void 0, n.onlyPlausible = !1), (n.lastOpeningBracketAt === void 0 || !n.onlyPlausible) && !n.quotes && (n.lastOpeningBracketAt = _e, n.slashPresent = !1, n.attributes = [], V === null ? n.leftOuterWhitespace = _e : l.trimOnlySpaces && V === 0 ? n.leftOuterWhitespace = w || _e : n.leftOuterWhitespace = V, "".concat(t[_e + 1]).concat(t[_e + 2]).concat(t[_e + 3]) == "!--" || "".concat(t[_e + 1]).concat(t[_e + 2]).concat(t[_e + 3]).concat(t[_e + 4]).concat(t[_e + 5]).concat(t[_e + 6]).concat(t[_e + 7]).concat(t[_e + 8]) == "![CDATA[")) {
        var _s9 = !0;
        t[_e + 2] === "-" && (_s9 = !1);
        var _a4;
        for (var _r = _e; _r < h; _r++) {
          if ((!_a4 && _s9 && "".concat(t[_r - 2]).concat(t[_r - 1]).concat(t[_r]) == "]]>" || !_s9 && "".concat(t[_r - 2]).concat(t[_r - 1]).concat(t[_r]) == "-->") && (_a4 = _r), _a4 && (_a4 < _r && t[_r].trim() || t[_r + 1] === void 0)) {
            var _g2 = _r;
            (t[_r + 1] === void 0 && !t[_r].trim() || t[_r] === ">") && (_g2 += 1), (!b.length || b[b.length - 1][0] !== n.lastOpeningBracketAt) && b.push([n.lastOpeningBracketAt, _a4 + 1]), (!$.length || $[$.length - 1][0] !== n.lastOpeningBracketAt) && $.push([n.lastOpeningBracketAt, _a4 + 1]);
            var _u2 = L(t, _r, n.leftOuterWhitespace, _g2, n.lastOpeningBracketAt, _a4);
            l.cb({
              tag: n,
              deleteFrom: n.leftOuterWhitespace,
              deleteTo: _g2,
              insert: _u2,
              rangesArr: i,
              proposedReturn: [n.leftOuterWhitespace, _g2, _u2]
            }), _e = _r - 1, t[_r] === ">" && (_e = _r), n = {}, o = {};
            break;
          }
        }
      }
    }
    !t[_e].trim() || t[_e].charCodeAt(0) === 847 ? (V === null && (V = _e, n.lastOpeningBracketAt !== void 0 && n.lastOpeningBracketAt < _e && n.nameStarts && n.nameStarts < n.lastOpeningBracketAt && _e === n.lastOpeningBracketAt + 1 && !c.some(function (s) {
      return s.name === n.name;
    }) && (n.onlyPlausible = !0, n.name = void 0, n.nameStarts = void 0)), (t[_e] === "\n" || t[_e] === "\r") && (N = _e, J && (J = !1))) : (V !== null && (!n.quotes && o.equalsAt > V - 1 && o.nameEnds && o.equalsAt > o.nameEnds && t[_e] !== '"' && t[_e] !== "'" && (te(o) && n.attributes.push(o), o = {}, n.equalsSpottedAt = void 0), V = null), J || (J = !0, F && !C && typeof N == "number" && _e && N < _e - 1 && (t.slice(N + 1, _e).trim() ? N = null : i.push([N + 1, _e])))), t[_e] === " " ? w === null && (w = _e) : w !== null && (w = null), n.name === "script" && (C = !n.slashPresent);
    e = _e;
  };
  for (var e = 0; e < h; e++) {
    var _ret2 = _loop2(e);
    if (_ret2 === "continue") continue;
  }
  if (t && (l.trimOnlySpaces && t[0] === " " || !l.trimOnlySpaces && !t[0].trim())) for (var _e2 = 0; _e2 < h; _e2++) {
    if (l.trimOnlySpaces && t[_e2] !== " " || !l.trimOnlySpaces && t[_e2].trim()) {
      i.push([0, _e2]);
      break;
    } else t[_e2 + 1] || i.push([0, _e2 + 1]);
  }
  if (t && (l.trimOnlySpaces && t[~-t.length] === " " || !l.trimOnlySpaces && !t[~-t.length].trim())) {
    for (var _e3 = t.length; _e3--;) {
      if (l.trimOnlySpaces && t[_e3] !== " " || !l.trimOnlySpaces && t[_e3].trim()) {
        i.push([_e3 + 1, h]);
        break;
      }
    }
  }
  var O = i.current();
  if ((!m || !m.cb) && O) {
    if (O[0] && !O[0][0]) {
      var _e4 = O[0][1];
      i.ranges[0] = [i.ranges[0][0], i.ranges[0][1]];
    }
    if (O[O.length - 1] && O[O.length - 1][1] === t.length) {
      var _e5 = O[O.length - 1][0];
      if (i.ranges) {
        var s = i.ranges[i.ranges.length - 1][0];
        t[s - 1] && (l.trimOnlySpaces && t[s - 1] === " " || !l.trimOnlySpaces && !t[s - 1].trim()) && (s -= 1);
        var a = i.ranges[i.ranges.length - 1][2];
        i.ranges[i.ranges.length - 1] = [s, i.ranges[i.ranges.length - 1][1]], (a === null || a === void 0 ? void 0 : a.trim()) && i.ranges[i.ranges.length - 1].push(a.trimEnd());
      }
    }
  }
  return {
    log: {
      timeTakenInMilliseconds: Date.now() - D
    },
    result: me(t, i.current()),
    ranges: i.current(),
    allTagLocations: b,
    filteredTagLocations: $
  };
}
export { oe as defaults, be as stripHtml, Ne as version };